import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Home, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-background">
      <div className="max-w-md w-full rounded-3xl gradient-sapphire text-white p-8 md:p-10 text-center shadow-elevated relative overflow-hidden">
        <div className="absolute inset-0 bg-mesh opacity-20" />
        <div className="relative space-y-4">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/70">Error 404</p>
          <h1 className="text-6xl md:text-7xl font-extrabold tracking-tight">Oops!</h1>
          <p className="text-white/80">We couldn't find the page you're looking for.</p>
          <div className="flex flex-col sm:flex-row gap-2 justify-center pt-2">
            <Link to="/">
              <Button size="lg" className="rounded-full bg-white text-primary hover:bg-white/90 w-full sm:w-auto">
                <Home className="h-4 w-4 mr-2" /> Home
              </Button>
            </Link>
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 text-white hover:bg-white/10 px-6 h-11 text-sm font-medium transition-colors"
            >
              <ArrowLeft className="h-4 w-4" /> Go back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
